<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    import 'normalize.css';
    import 'flex-layout-attribute';
    import '@/app.scss'
    import Vue from 'vue'


    export default {
        components: {},
        name: 'App',

        methods: {},
        mounted() {
            const cb = () => {
                this.$bus.$off('loaded', cb);
                const preloader = document.getElementById('preloader');
                TweenLite.to(preloader, 0.2, {
                    opacity: 0, delay:1, onComplete: () => {
                        preloader.style.display = 'none';
                    }
                });
            };
            this.$bus.$on('loaded', cb);
            cb();
        }
    }
</script>

<style lang="scss">

</style>
